import { render, staticRenderFns } from "./EditActivityTaskDialog.vue?vue&type=template&id=4570dc58&scoped=true"
import script from "./EditActivityTaskDialog.vue?vue&type=script&lang=js"
export * from "./EditActivityTaskDialog.vue?vue&type=script&lang=js"
import style0 from "./EditActivityTaskDialog.vue?vue&type=style&index=0&id=4570dc58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4570dc58",
  null
  
)

export default component.exports